<template>
  <section class="teacher-login-container">
    <div class="container">
      <form @submit.prevent="handleForm" class="login-grid">
        <div class="login-grid--form">
          <div v-if="mailIsAlreadyUsed === '1'" class="already-registered">
            <div class="icon">
              <i class="far fa-check-circle"></i>
            </div>
            <div class="text">
              You are already registered!
            </div>
          </div>

          <p class="description">
            Please login to our platform to continue
          </p>

          <div class="input-group">
            <label for="">
              Email
            </label>
            <input type="text" class="input-field" v-model="email" placeholder="johndoe@mail.com" required>
            <span class="span-placeholder">
              <i class="far fa-user"></i>
            </span>
          </div>

          <div class="input-group">
            <label for="">
              Password
            </label>
            <input type="password" class="input-field" v-model="password" placeholder="**********" required>
            <span class="span-placeholder">
              <i class="fas fa-lock"></i>
            </span>
          </div>

          <button type="submit" class="btn btn-teacher-form">
            LOGIN
          </button>

          <div class="form-extras">
            <a href="/teachers/reset-password">
              <sup>*</sup>
              Forgot your password
            </a>

            <p>
              Don't have an account?
              <a href="/home">
                SIGN UP
              </a>
            </p>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import TeacherService from '../../services/TeacherService'
import { waitingAlert } from '../../utils/alerts'

const service = new TeacherService()

export default {
  name: 'TeachersLogin',
  props: {
    mailIsAlreadyUsed: {
      default: () => false
    }
  },
  data () {
    return {
      email: null,
      password: null
    }
  },
  methods: {
    async handleForm () {
      waitingAlert('Login in, please wait ...')
      await service.login({ email: this.email, password: this.password })
    }
  }
}
</script>

<style lang="scss" scoped>
.span-placeholder {
  position: absolute;
  top: 45px;
  left: 20px;
  font-size: 16px;
  color: #999999;
}

.form-extras {
  font-family: 'Rubik';
  font-weight: 500;
  color: #999;
  font-size: 18px;
  line-height: 22px;
  text-align: center;

  a {
    color: #999;
    display: block;
    text-decoration: underline;
    margin-bottom: 15px;
  }
}

.input-field {
  border-width: 1px;
}
</style>



// WEBPACK FOOTER //
// resources/js/views/TeachersForm/Login.vue